<template>
  <div class="x-tablelist-view" data-automation="group">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="search"
      @input="search"
      @add="showAdd"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        :emptyText="$t('HT.nodata')"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addMsgTemp from './template/addMsgTemp';
import exchannels from './template/exchannels';
// import changeMsgTemp from './template/changeMsgTemp';
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          hideBtn: true,
          placeholder: '请输入模板名称进行搜索'
        },
        {
          type: 'input',
          key: 'code',
          hideBtn: true,
          placeholder: '请输入模板编码进行搜索'
        },
        {
          type: 'input',
          key: 'content',
          hideBtn: true,
          placeholder: '请输入模板内容进行搜索'
        },
        {
          type: 'button',
          text: '查询',
          show: true,
          event: 'search'
        },
        {
          type: 'button',
          text: '添加模板',
          hidden: !this.$hasModule(38),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: '模板名称',
          tooltip: true,
          prop: 'name'
        },
        {
          label: '模板编码',
          prop: 'code',
          tooltip: true
        },
        {
          label: '模板内容',
          tooltip: true,
          minWidth: 160,
          // align: 'left',
          render: (h, params) => {
            let showContent = '';
            if (params.sign) {
              showContent = `【${params.sign.name}】 ${params.content}`;
            } else {
              showContent = params.content;
            }
            return h('span', {}, showContent);
          }
        },
        {
          label: '模板类型',
          prop: 'type',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.tempType);
          }
        },
        {
          label: '审核状态',
          prop: 'status',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.SmsStatus);
          }
        },
        {
          label: '模板支持的通道',
          minWidth: 120,
          tooltip: true,
          render: (h, params) => {
            return h(exchannels, {
              props: {
                list: params.channels,
                channelOption: this.channelOption
              }
            });
          }
        },
        {
          label: '阿里云模板ID',
          prop: 'temp_id',
          minWidth: 120,
          tooltip: true
        },
        {
          label: '创建时间',
          prop: 'created_date',
          tooltip: true
        },
        {
          label: '操作',
          hidden: !this.$hasModule(38),
          width: 180,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: ['启用', '禁用', '修改', '删除'],
                className: [
                  params.disabled ? '' : 'no-click',
                  !params.disabled ? '' : 'no-click',
                  '',
                  ''
                ],
                colors: ['#0087ff', '#f45c5c', '#0087ff', '#f45c5c'],
                event: ['start', 'disabled', 'toChange', 'del']
              },
              on: {
                start: () => {
                  const startData = { code: params.code, disabled: false };
                  this.changeStatus(startData);
                },
                disabled: () => {
                  const disabledData = { code: params.code, disabled: true };
                  this.changeStatus(disabledData);
                },
                toChange: () => {
                  this.$uxModal.show({
                    title: '修改模板',
                    content: (h) => {
                      let resData = JSON.parse(JSON.stringify(params));
                      resData.sign_id = resData.sign && resData.sign.id;
                      return h(addMsgTemp, {
                        props: {
                          signOption: this.signOption,
                          channelOption: this.channelOption,
                          data: resData
                        }
                      });
                    },
                    confirm: (data) => {
                      let resData = JSON.parse(JSON.stringify(data));
                      resData.channels = resData.channels.join(','); //后端需要这种格式
                      this.changeMsgTemp(resData);
                    }
                  });
                },
                del: () => {
                  this.$uxModal.show({
                    title: '删除模板',
                    content: '请确定该模板已不再使用！',
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: null, // 模板名称
        code: null, // 模板code
        content: null, // 模板内容
        page: 1,
        size: 10
      },
      filter2: {
        // 查询参数
        page: 1,
        size: 1000
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      signOption: [], //选择签名
      channelOption: [] //选择通道
    };
  },
  created() {
    this.getList(this.filter);
    this.getSign(this.filter2);
    this.getChannel(this.filter2);
  },

  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.message.getTemp(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addMsgTemp(params) {
      this.$uxLoading.show();
      params.disabled = false;
      this.$api.message.addTemp(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('添加成功');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    changeMsgTemp(params) {
      this.$uxLoading.show();
      this.$api.message.changeTemp(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('修改成功');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 修改审批状态
     * @param {Object} params 表单提交参数
     */
    changeStatus(params) {
      this.$uxLoading.show();
      this.$api.message.changeTemp(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          params.disabled
            ? this.$uxMessage.success('禁用成功')
            : this.$uxMessage.success('启用成功');
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.message.delTemp(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success('删除成功');
          this.getList(this.filter);
        }
      });
    },
    /**
     * 获取签名
     */
    getSign(params) {
      this.$api.message.getSign(params).then((res) => {
        if (res.code == 10000) {
          let list = [];
          for (let index = 0; index < res.data.length; index++) {
            let item = res.data[index];
            list.push({
              id: item.id,
              name: item.name,
              disabled: item.status === 0 ? true : false
            });
          }
          this.signOption = list;
        }
      });
    },

    /**
     * 获取通道
     */
    getChannel(params) {
      // this.$uxLoading.show();
      this.$api.message.getChannel(params).then((res) => {
        if (res.code == 10000) {
          this.channelOption = res.data || [];
        }
      });
    },

    /**
     * 新建分组弹窗
     */
    showAdd() {
      this.$uxModal.show({
        title: '添加模板',
        content: (h) => {
          return h(addMsgTemp, {
            props: {
              signOption: this.signOption,
              channelOption: this.channelOption
            }
          });
        },
        confirm: (params) => {
          let postData = JSON.parse(JSON.stringify(params));
          postData.channels = postData.channels.join(','); //后端需要这种格式
          this.addMsgTemp(postData);
        }
      });
    },

    /**
     * 点击搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
